var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.787 8.643L.02 11.957a.833.833 0 00.809 1.01.814.814 0 00.173 0l3.335-.767L10.74 5.82 7.166 2.256.787 8.643zM12.752 2.628L10.367.244a.837.837 0 00-1.18 0L7.861 1.569l3.57 3.57 1.325-1.326a.837.837 0 00-.004-1.185z",
    fill: "#6B6B6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default ForwardRef;